import API from './api';

export const leaveService = {
  // Get leave types
  getLeaveTypes: () => API.get('/leaves/types'),
  
  // Get employee leave balance
  getLeaveBalance: (employeeId) => API.get(`/leaves/balance/${employeeId}`),
  
  // Preview chargeable days for a date range
  calculateLeave: (data) => API.post('/leaves/calculate', data),

  // Apply for leave
  applyForLeave: (data) => API.post('/leaves/apply', data),
  
  // Get leave applications
  getLeaveApplications: (params) => API.get('/leaves/applications', { params }),
  
  // Get single leave application
  getLeaveApplicationById: (id) => API.get(`/leaves/applications/${id}`),
  
  // Process leave application
  processLeaveApplication: (id, data) => API.put(`/leaves/applications/${id}`, data),
  
  // Cancel leave application
  cancelLeaveApplication: (id) => API.delete(`/leaves/applications/${id}`),
  
  // Get leave statistics
  getLeaveStatistics: () => API.get('/leaves/stats'),
  
  // Check leave conflict for specific date
  checkLeaveConflict: (date) => API.get(`/leaves/check-conflict/${date}`),
};
